import React, {
  ReactNode,
} from 'react';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import SupportPortalOptionCard from 'views/EMR/PopulateSupport/SupportPortalOptionCard';

export type SupportPortalSection = 'impersonation' | 'knowledgeBase' | 'queryExecution';

type SupportOption = {
  title: string;
  description: string;
  icon: ReactNode;
  section: SupportPortalSection;
};

const supportOptions = Object.freeze<SupportOption[]>([
  {
    title: 'Impersonation',
    description: 'Access customer accounts safely to diagnose issues and verify support outcomes.',
    icon: <ManageAccountsRoundedIcon />,
    section: 'impersonation',
  },
  {
    title: 'How-To / Knowledge Base',
    description: 'Browse internal articles and step-by-step instructions for common support tasks.',
    icon: <MenuBookRoundedIcon />,
    section: 'knowledgeBase',
  },
  {
    title: 'Query Execution',
    description: 'Launch natural-language query tools for internal support analysis and investigation.',
    icon: <TravelExploreRoundedIcon />,
    section: 'queryExecution',
  },
]);

type Props = {
  onSelectSection: (section: SupportPortalSection) => void;
};

export default function SupportPortalLanding({ onSelectSection }: Props) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-10 shadow-sm">
      <div className="mb-8 flex flex-col gap-3">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">
          Choose a support workflow
        </h1>
        <p className="max-w-3xl text-sm text-slate-600 md:text-base">
          Start with the workflow you need. Each section is tailored for daily support operations.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {supportOptions.map((option) => (
          <SupportPortalOptionCard
            key={option.section}
            title={option.title}
            description={option.description}
            icon={option.icon}
            onClick={() => onSelectSection(option.section)}
          />
        ))}
      </div>
    </div>
  );
}
